// extracted by mini-css-extract-plugin
module.exports = {"containerSidebar":"container-sidebar_containerSidebar__b74SW","lg":"container-sidebar_lg__L_FEQ","main":"container-sidebar_main__DeTxx"};